import { useCallback, useEffect, useMemo, useState } from "react";

import useProfile from "../profile/useProfile";

const stripId = (address) => {
  if (!address) return null;

  const { id, ...rest } = address;

  return rest;
};

const useDeliveryAddress = () => {
  const { profile, loading, fetchProfile } = useProfile();
  const [address, setAddressState] = useState(null);
  const [seeded, setSeeded] = useState(false);

  useEffect(() => {
    if (!profile && !loading) fetchProfile();
  }, [profile, loading, fetchProfile]);

  useEffect(() => {
    if (seeded || address || !profile?.address) return;

    setAddressState(stripId(profile.address));
    setSeeded(true);
  }, [profile, address, seeded]);

  const setAddress = useCallback((next) => setAddressState(stripId(next)), []);

  const hasCoordinates = useMemo(() => {
    const latitude = Number(address?.latitude);
    const longitude = Number(address?.longitude);

    return Number.isFinite(latitude) && Number.isFinite(longitude);
  }, [address]);

  return { address, setAddress, hasCoordinates };
};

export default useDeliveryAddress;
